import Event from '../../core/Event';
import UserOrder from '../../../domain/UserOrder';

export default class UserOrdersGetSucceed extends Event {
    public static type = 'UserOrdersGetSucceed';

    constructor(public readonly orders: UserOrder[]) {
        super(UserOrdersGetSucceed.type);
    }
}



// WEBPACK FOOTER //
// ./src/application/order/events/UserOrdersGetSucceed.ts